export enum UtilityTypes {
	hoist = 'hoist',
	scissorsLift = 'scissorsLift',
}
